import { Component, OnInit } from '@angular/core';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { NewPageList } from '../../core/models/new-page-list';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';

import { firebase } from '@firebase/app';
import { NewPagePref } from '../../core/models/new-page-prefs';
import { Constants } from '../../core/config/Constants';
@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css'],
  providers: [NewPageService]
})
export class VideoComponent implements OnInit {

  file_error_summary = Constants.VIDEO_SIZE_ERROR_MESSAGE_SUMMARY;
  file_error_detail = Constants.VIDEO_SIZE_ERROR_MESSAGE_DETAIL;
  file_size = Constants.VIDEO_SIZE;
  VIDEO_LABEL = Constants.VIDEO_SIZE_LABEL;

  aboutUs: NewPageList;

  eventId: string;
  cmCategory: string;
  eventVideos: boolean = true;

  uploadFileName: string = null;
  uploadprogress: number = null;

  constructor(private newPageService: NewPageService, private confirmationService: ConfirmationService) {

  }

  ngOnInit() {
    this.aboutUs.aboutPrefs = new NewPagePref();
  }

  src = null;
  _ref: any;

  onBasicUpload(event) {
    console.log();
    if (event.files[0]) {
      this.newPageService.uploadFile(this.eventId, event.files[0], this.cmCategory).on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          if (event.files[0]) {
            this.uploadFileName = event.files[0].filename;
            this.uploadprogress = Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          }
        },
        (error) => {
        },
        () => {
          if (event.files[0]) {
            let contentsMandatory = new ContentsMandatory();
            if (this.cmCategory) {
              contentsMandatory.category = this.cmCategory;
            } else {
              contentsMandatory.category = Constants.CONTENT_M_TYPE_ABOUT;
            }
            contentsMandatory.eventId = this.eventId;
            contentsMandatory.filename = event.files[0].name;
            contentsMandatory.sizeInBytes = event.files[0].size;
            contentsMandatory.extension = event.files[0].type.split('/').pop();
            console.log(contentsMandatory);
            let key = this.newPageService.addContentMandatory(contentsMandatory);
            this.aboutUs.contentMandatoryList = new Array();
            this.aboutUs.contentMandatoryList.push(key);
          }
          //   this.newPageService.getFile(contentsMandatory,this.eventId).then((url) => {
          //     this.src = url ;
          // });
        }
      );
    }
  }
  deleteImage() {
    this.aboutUs.contentMandatoryList = new Array();
    this.uploadFileName = null;
    this.uploadprogress = null;
  }

  confirmDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete ?',
      accept: () => {
        this.remove();
      }
    });
  }

  remove() {
    this._ref.destroy();
    this.newPageService.removeItem(this.aboutUs);
  }

  upItem() {
    this.newPageService.upItem(this.aboutUs);
  }

  downItem() {
    this.newPageService.downItem(this.aboutUs);
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/video/video.component.ts